import * as React from 'react';
import { connect } from 'react-redux';
import './Diagnosis.css';
import { types } from '../../constants/types';
import { ChunkDetailsMO } from '../../models/ChunkDetailsMO';
import { IconButton, DirectionalHint } from '@fluentui/react';
import { ChunkListMO } from '../../models/ChunkListMO';
import { ThemeMO } from '../../models/ThemeMO';
import { GraphCheckListMO } from '../../models/GraphCheckListMO';
import { WordManager } from '../../Manager/WordManager';
import { ConfigManager } from '../../Manager/ConfigManager';
import AppCallout from '../AppCallout/AppCallout';

import { faFileAlt, faCopy } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export interface AppProps {
	//
	chunkDetailsMO: ChunkDetailsMO;
	setChunkDetailsMO;

	chunkListMO: ChunkListMO;
	setWordTypeScoreMO;

	themeMO: ThemeMO;

	graphCheckListMO: GraphCheckListMO;
}

export interface AppState {
	isCalloutVisible: boolean;
}

// detect chunkList size
class Diagnosis extends React.Component<AppProps, AppState> {
	constructor(props, context) {
		super(props, context);

		this.state = { isCalloutVisible: false };
	}
	closeButtonHandler = () => {
		const {
			setChunkDetailsMO,
			chunkDetailsMO,
			chunkListMO,
			setWordTypeScoreMO,
		} = this.props;

		if (chunkListMO.length > 1) {
			chunkDetailsMO.isShow = false;
			setChunkDetailsMO(chunkDetailsMO);
			setWordTypeScoreMO(chunkListMO.wordTypeScore);
		}
	};

	getChunkDetailsRating() {
		//
		const { chunkDetailsMO, graphCheckListMO } = this.props;
		let result: number;

		if (graphCheckListMO.cVerb === true) {
			result = WordManager.verifyScore(
				chunkDetailsMO.data.wordTypeScore.verbScore,
			);
		} else if (graphCheckListMO.cNoun === true) {
			result = WordManager.verifyScore(
				chunkDetailsMO.data.wordTypeScore.nounScore,
			);
		} else if (graphCheckListMO.cPrep === true) {
			result = WordManager.verifyScore(
				chunkDetailsMO.data.wordTypeScore.prepScore,
			);
		} else if (graphCheckListMO.cAd_ === true) {
			result = WordManager.verifyScore(
				chunkDetailsMO.data.wordTypeScore.ad_Score,
			);
		} else if (graphCheckListMO.cWaste === true) {
			result = WordManager.verifyScore(
				chunkDetailsMO.data.wordTypeScore.wasteScore,
			);
		} else {
			result = WordManager.verifyScore(
				chunkDetailsMO.data.wordTypeScore.average,
			);
		}

		return result;
	}

	getChunkListRating() {
		//
		const { chunkListMO, graphCheckListMO } = this.props;
		let result: number;
		if (graphCheckListMO.cVerb === true) {
			result = WordManager.verifyScore(chunkListMO.wordTypeScore.verbScore);
		} else if (graphCheckListMO.cNoun === true) {
			result = WordManager.verifyScore(chunkListMO.wordTypeScore.nounScore);
		} else if (graphCheckListMO.cPrep === true) {
			result = WordManager.verifyScore(chunkListMO.wordTypeScore.prepScore);
		} else if (graphCheckListMO.cAd_ === true) {
			result = WordManager.verifyScore(chunkListMO.wordTypeScore.ad_Score);
		} else if (graphCheckListMO.cWaste === true) {
			result = WordManager.verifyScore(chunkListMO.wordTypeScore.wasteScore);
		} else {
			result = WordManager.verifyScore(chunkListMO.wordTypeScore.average);
		}

		return result;
	}

	getRating() {
		const { chunkListMO, chunkDetailsMO, themeMO } = this.props;
		if (chunkListMO.isFewWordCount) {
			return '';
		}
		let rating =
			chunkDetailsMO.isShow === true
				? themeMO.ratings[this.getChunkDetailsRating()]
				: themeMO.ratings[this.getChunkListRating()];
		return themeMO.key !== 'sunny-weather' ? (
			rating
		) : (
			<span className="emoji-font">{rating}</span>
		);
	}
	getPercentage(percent: number, count: number) {
		if (percent === 0 && count > 0) {
			return '<1';
		}
		return percent.toString();
	}
	getMessage() {
		const { chunkDetailsMO, chunkListMO, graphCheckListMO } = this.props;
		let result: any = '';
		let summaryCalloutText = null;
		if (chunkListMO.isFewWordCount) {
			result = (
				<div>
					This sample has {chunkListMO.contentWordCount} eligible words. The
					Writer’s Diet test is not calibrated for writing samples under 100
					words.
				</div>
			);
		} else if (graphCheckListMO.cVerb === true) {
			let label = ConfigManager.getMetrics().Verbs.label;
			if (chunkDetailsMO.isShow && chunkListMO.length > 1) {
				summaryCalloutText = `Region diagnosis (${label})`;
				result = `${label}: ${this.getPercentage(
					chunkDetailsMO.data.wordTypeScore.verbRating,
					chunkDetailsMO.data.wordTypeCount.verb,
				)}% of region.`;
			} else {
				summaryCalloutText = `Document diagnosis (${label})`;
				result = `${label}: ${this.getPercentage(
					chunkListMO.wordTypeScore.verbRating,
					chunkListMO.wordTypeCount.verb,
				)}% of sample.`;
			}
		} else if (graphCheckListMO.cNoun === true) {
			let label = ConfigManager.getMetrics().Nouns.label;
			if (chunkDetailsMO.isShow && chunkListMO.length > 1) {
				summaryCalloutText = `Region diagnosis (${label})`;
				result = `${label}: ${this.getPercentage(
					chunkDetailsMO.data.wordTypeScore.nounRating,
					chunkDetailsMO.data.wordTypeCount.noun,
				)}% of region.`;
			} else {
				summaryCalloutText = `Document diagnosis (${label})`;
				result = `${label}: ${this.getPercentage(
					chunkListMO.wordTypeScore.nounRating,
					chunkListMO.wordTypeCount.noun,
				)}% of sample.`;
			}
		} else if (graphCheckListMO.cPrep === true) {
			let label = ConfigManager.getMetrics().Prepositions.label;
			if (chunkDetailsMO.isShow && chunkListMO.length > 1) {
				summaryCalloutText = `Region diagnosis (${label})`;
				result = `${label}: ${this.getPercentage(
					chunkDetailsMO.data.wordTypeScore.prepRating,
					chunkDetailsMO.data.wordTypeCount.prep,
				)}% of region.`;
			} else {
				summaryCalloutText = `Document diagnosis (${label})`;
				result = `${label}: ${this.getPercentage(
					chunkListMO.wordTypeScore.prepRating,
					chunkListMO.wordTypeCount.prep,
				)}% of sample.`;
			}
		} else if (graphCheckListMO.cAd_ === true) {
			let label = ConfigManager.getMetrics().AdjectivesAdverbs.label;
			if (chunkDetailsMO.isShow && chunkListMO.length > 1) {
				summaryCalloutText = `Region diagnosis (${label})`;
				result = `${label}: ${this.getPercentage(
					chunkDetailsMO.data.wordTypeScore.ad_Rating,
					chunkDetailsMO.data.wordTypeCount.ad_,
				)}% of region.`;
			} else {
				summaryCalloutText = `Document diagnosis (${label})`;
				result = `${label}: ${this.getPercentage(
					chunkListMO.wordTypeScore.ad_Rating,
					chunkListMO.wordTypeCount.ad_,
				)}% of sample.`;
			}
		} else if (graphCheckListMO.cWaste === true) {
			let label = ConfigManager.getMetrics().WasteWords.label;
			if (chunkDetailsMO.isShow && chunkListMO.length > 1) {
				summaryCalloutText = `Region diagnosis (${label})`;
				result = `${label}: ${this.getPercentage(
					chunkDetailsMO.data.wordTypeScore.wasteRating,
					chunkDetailsMO.data.wordTypeCount.waste,
				)}% of region.`;
			} else {
				summaryCalloutText = `Document diagnosis (${label})`;
				result = `${label}: ${this.getPercentage(
					chunkListMO.wordTypeScore.wasteRating,
					chunkListMO.wordTypeCount.waste,
				)}% of sample.`;
			}
		} else {
			if (chunkDetailsMO.isShow && chunkListMO.length > 1) {
				summaryCalloutText = `Region diagnosis (all categories)`;
				result = `This region has ${chunkDetailsMO.data.contentWordCount} eligible words.`;
			} else {
				summaryCalloutText = `Document diagnosis (all categories)`;
				if (chunkListMO.contentWordCount === 1000) {
					result =
						'This sample has 1000 eligible words.  To test a longer sample, download the MS Word app.';
				} else {
					result = `This sample has ${chunkListMO.contentWordCount} eligible words.`;
				}
			}
		}

		return (
			<div onClick={this.showDiagnosisCallout}>
				{this.state.isCalloutVisible
					? this.renderCallout(summaryCalloutText)
					: ''}
				<div className="diagnosis-container-footer">{result} </div>
			</div>
		);
	}

	getIconColor() {
		const { graphCheckListMO } = this.props;

		let result = '';

		if (graphCheckListMO.cVerb === true) {
			result = ConfigManager.getMetrics().Verbs.color;
		} else if (graphCheckListMO.cNoun === true) {
			result = ConfigManager.getMetrics().Nouns.color;
		} else if (graphCheckListMO.cPrep === true) {
			result = ConfigManager.getMetrics().Prepositions.color;
		} else if (graphCheckListMO.cAd_ === true) {
			result = ConfigManager.getMetrics().AdjectivesAdverbs.color;
		} else if (graphCheckListMO.cWaste === true) {
			result = ConfigManager.getMetrics().WasteWords.color;
		} else {
			result = '#fff';
		}

		return result;
	}
	renderCallout = (text) => {
		if (text == null || text === '') {
			this.setState({ isCalloutVisible: false });
			return '';
		}
		const onCalloutDismiss = () => {
			this.setState({ isCalloutVisible: false });
		};

		return (
			<AppCallout
				key={'_callout_dianosis'}
				target={'.diagnosis-container'}
				directionalHint={DirectionalHint.topCenter}
				onDismiss={() => {
					onCalloutDismiss();
				}}
				text={text}
				onClick={() => {
					onCalloutDismiss();
				}}></AppCallout>
		);
	};
	private showDiagnosisCallout = () => {
		this.setState({ isCalloutVisible: !this.state.isCalloutVisible });
	};
	render() {
		const { chunkDetailsMO, chunkListMO } = this.props;
		const regionBackgroundColor = '#5f5ba4'; // dark purple
		const documentBackgroundColor = '#69696c'; // dark grey

		return (
			<div
				className="diagnosis-container"
				style={{
					...{
						backgroundColor:
							chunkDetailsMO.isShow && chunkListMO.length > 1
								? regionBackgroundColor
								: documentBackgroundColor,
					},

					color: 'white',
				}}>
				<div className="diagnosis-container-top">
					<div className="diagnosis-header" onClick={this.showDiagnosisCallout}>
						{chunkDetailsMO.isShow === true && chunkListMO.length > 1 ? (
							<FontAwesomeIcon
								icon={faCopy}
								className="diagnosis-icon"
								style={{ color: this.getIconColor() }}
							/>
						) : (
							<FontAwesomeIcon
								icon={faFileAlt}
								className="diagnosis-icon"
								style={{ color: this.getIconColor() }}
							/>
						)}
						{this.getRating()}
					</div>
					<div className={'diagnosis-icon-container'}>
						{chunkDetailsMO.isShow && chunkListMO.length > 1 ? (
							<IconButton
								iconProps={{
									iconName: 'ChromeClose',
									styles: { root: { color: 'white' } },
								}}
								onClick={this.closeButtonHandler}
							/>
						) : (
							''
						)}
					</div>
				</div>
				{this.getMessage()}
			</div>
		);
	}
}

const mapDispatchToProps = (dispatch) => ({
	setChunkDetailsMO: (chunkDetailsMO) => {
		dispatch({
			type: types.SET_CHUNK_DETAILS,
			chunkDetailsMO: chunkDetailsMO,
		});
	},
	setWordTypeScoreMO: (wordTypeScoreMO) => {
		dispatch({
			type: types.SET_SCORE,
			wordTypeScoreMO: wordTypeScoreMO,
		});
	},
});

const mapStateToProps = ({
	chunkDetailsMO,
	chunkListMO,
	themeMO,
	graphCheckListMO,
}) => ({
	chunkDetailsMO,
	chunkListMO,
	themeMO,
	graphCheckListMO,
});

export default connect(mapStateToProps, mapDispatchToProps)(Diagnosis);
